module.exports = __webpack_public_path__ + "img/selected0-min.92176f87.png";